import { SubscriptionPlanId } from "@/features/subscription/types";
import type { UserSubscription } from "@/features/subscription/types";
import { trialHasEnded } from "@/lib/utils/trial";

// Active paid subscriber = has a subscription, not expired, and not on a
// free-trial / pay-as-you-go plan. Display-only — the server enforces offer
// eligibility independently; never use this to gate a data fetch or write.
export function isActivePaidSubscriber(subscription: UserSubscription | undefined): boolean {
  return (
    !!subscription &&
    !subscription.isExpired &&
    subscription.planId !== SubscriptionPlanId.Speak_Free_Trial &&
    subscription.planId !== SubscriptionPlanId.Speak_Pay_As_You_Go
  );
}

/** True while the account is on the free trial and the trial has not ended. */
export function isTrialActive(subscription: Pick<UserSubscription, "planId" | "isExpired" | "remainingDays"> | undefined): boolean {
  return (
    subscription?.planId === SubscriptionPlanId.Speak_Free_Trial &&
    !trialHasEnded(subscription.isExpired, subscription.remainingDays)
  );
}
